// TODO Fix Type
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unsafe-call */
// ANCHOR Payloads
import {
  ICreateCourseModulePayload,
  IDeleteCourseModulePayload,
  IGetCourseModulesPayload,
  IUpdateCourseModuleOrderPayload,
  IUpdateCourseModulePayload,
} from './payloads/course-module';

// ANCHOR Results
import { ICourseModuleResult } from './results/course-module';
import { MODULE_ITEM_TYPE } from './results/module-item';
import { EnumNumberFive } from './results/ondemand';

export async function getCourseModules(
  { courseId }: IGetCourseModulesPayload,
): Promise<ICourseModuleResult[]> {
  const { sdk } = await import('../axios/graphql');
  const response = await sdk().GetCourseModules({
    id: courseId,
  });

  if (response.modules) {
    return response.modules.map((module) => ({
      ...module,
      moduleItems: module.moduleItems.map((item) => ({
        ...item,
        itemType: MODULE_ITEM_TYPE[item.itemType as EnumNumberFive],
      })),
    }) as ICourseModuleResult);
  }

  return response.modules;
}

export async function createCourseModule(
  { token, courseId, ...payload }: ICreateCourseModulePayload,
) {
  const { sdk } = await import('../axios/graphql');

  await sdk(token).CreateCourseModule({
    id: courseId,
    ...payload,
    order: payload.order ?? 0,
  });
}

export async function updateCourseModule(
  { token, moduleId, ...payload }: IUpdateCourseModulePayload,
) {
  const { sdk } = await import('../axios/graphql');

  await sdk(token).UpdateCourseModuleById({
    id: moduleId,
    ...payload,
  });
}

export async function updateCourseModuleOrder(
  { token, moduleId, order }: IUpdateCourseModuleOrderPayload,
) {
  const { sdk } = await import('../axios/graphql');

  await sdk(token).UpdateCourseModuleOrderById({
    id: moduleId,
    order,
  });
}

export async function deleteCourseModule(
  { token, courseModuleId }: IDeleteCourseModulePayload,
) {
  const { sdk } = await import('../axios/graphql');
  await sdk(token).DeleteCourseModuleById({
    id: courseModuleId,
  });
}
